﻿{
  "community": {
    "name": "Сообщество",
    "titles": {
      "1": "Онлайн-сообщество",
      "2": "Найти материалы",
      "3": "Поделитесь своими созданиями"
    },
    "body": {
      "1": "Отличное место для начала работы и знакомства с предложениями Boardmaker.",
      "2": "Посмотрите, что создают другие и чем они делятся друг с другом. Это своего рода окно в мир магии Boardmaker!",
      "3": "С помощью выбранного Вами программного обеспечения Boardmaker Вы сможете загружать свои творения и делиться ими с сообществом."
    }
  },
  "personal": {
    "name": "Подписка для личного использования",
    "header": "Включает в себя подписку ''Онлайн-сообщество'' плюс:",
    "titles": {
      "1": "Создание, редактирование, воспроизведение и печать",
      "2": "Программное обеспечение Boardmaker"
    },
    "body": {
      "1": "Для родителя или лица, осуществляющего уход, с одним ребенком, который хочет создавать, редактировать, воспроизводить и печатать задания",
      "2": "Учетная запись включает в себя лицензию на программу Boardmaker 7, которая может быть установлена на 2 компьютерах на базе Windows"
    }
  },
  "professional": {
    "name": "Подписка для специалистов",
    "header": "Включает в себя подписку для личного использования плюс:",
    "titles": {
      "1": "Контроль учеников",
      "2": "Индивидуальные настройки"
    },
    "body": {
      "1": "Для преподавателей групп от 1 до 50 учащихся, которые хотят назначать задания и отслеживать данные об учащихся.",
      "2": "Индивидуальные настройки доступа для различных учащихся"
    }
  },
  "organization": {
    "name": "Подписка для организаций",
    "header": "Включает в себя подписку для специалистов плюс:",
    "titles": {
      "1": "Команда многопредметной поддержки"
    },
    "body": {
      "1": "Установление цены в зависимости от объема, контроль информации со стороны организации и возможность назначения нескольких специалистов одним и тем же учащимся."
    }
  }
}
